





















import {Component, Vue, Watch} from "vue-property-decorator";
  import {RouterStore} from '@/interfaces/store-interfaces/router-store.interface';
  import {localStorageService} from "@/services/local-storage.service";
import {rhizomeResource} from "@/modules/Rhizome/resources/rhizome.resource";

  @Component({})
  export default class Menu extends Vue {
    baseUrl = process.env.VUE_APP_PUBLIC_URL;
    route = RouterStore.ROUTE_NAME;
    favoriteCount: number = 0;
    routePath = RouterStore.ROUTE_PATH;

    get isMenuOpen() {
      return this.$store.state.dialog.menu;
    }

    async openLink(routeName: RouterStore.ROUTE_NAME, showFavorite: boolean = false) {
      let routerParams: any = { routeName };

      if (this.$route.name === RouterStore.ROUTE_NAME.RHIZOME_PAGE) {
        if (!(this.$store.state.rhizome.filterByKeywordName)) {
          let response = await rhizomeResource.getList();
          this.$store.commit('rhizome/setPropertyInState', { name: 'filmsList', value: response });
          this.$store.commit('rhizome/setPropertyInState', { name: 'showFavorites', value: showFavorite });
        }
      }
      else if (showFavorite) this.$store.commit('rhizome/setPropertyInState', { name: 'showFavorites', value: showFavorite });

      await this.$store.dispatch('routerStore/openPage', routerParams);
      this.$store.commit('dialog/closeDialog', { dialogName: 'menu' });

      document.body.classList.remove('overflow');
    }

    @Watch('isMenuOpen')
    getFavoriteCount() {
      if (this.$store.state.dialog.menu) {
        this.favoriteCount = localStorageService.getFavoriteList().length;
      }
    }
  }
